import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/funnel-report")({
  component: lazyRouteComponent(() => import("./-pages/admin.funnel-report")),
  head: () => ({
    meta: [
      { title: "تقرير القمعات الشامل · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
